'use client';

import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const Container = styled.form`
  display: flex;
  flex-direction: column;

  gap: 20px;
`;

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;

  gap: 8px;
`;

export const FormRow = styled.div`
  display: flex;

  gap: 40px;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;

    gap: 8px;
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;
  padding: 0 60px;
  margin-top: 20px;

  background-color: ${colors.silver};
  border-radius: 16px;
  border: none;
  color: ${colors.dark};
  background-color: ${colors.light};
  font-weight: 600;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    background-color: ${colors.gray4};
    color: ${colors.gray5};

    &:hover {
      cursor: default;
    }
  }
`;
